import { Box } from "@mui/material";
import React, { Fragment } from "react";

const VerificationLayout = ({ children }) => {
  return (
    <Fragment>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh", // fallback for browsers without dvh support
          "@supports (height: 100dvh)": {
            height: "100dvh",
          },
          p: { xs: 0, sm: 2 },
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            boxShadow:
              "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
            height: "100%",
            width: {
              xs: "100%", // Mobile
              sm: "100%", // Tablet small
              md: "100%", // Tablet landscape
              lg: "45%", // Desktop
            },
            border: "none",
            borderRadius: "6px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            p: {
              xs: "16px",
              sm: "20px",
              md: "30px",
              lg: "20px",
            },
            backgroundColor: "white",
            overflow: "hidden",
            boxSizing: "border-box",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              height: "100%",
              flex: 1,
              minHeight: 0, 
              justifyContent: "space-between",
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Fragment>
  );
};

export default VerificationLayout;